import { Component, OnInit, Input } from '@angular/core';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { tPaymentModel } from 'src/app/models/tPaymentModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPaymentService } from 'src/app/services/tPayment.service';
import { ChangeUnpaidModel } from 'src/app/models/tChangeAcctModel';
import { decimalplaceHandler } from 'src/app/services/Non-Master/decimalplaceHandler.service';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { tBillPayModel, BillPay_ItemType } from 'src/app/models/tBillPayModel';
import { BillPayPaymentMethod_ehCardDialogService } from 'src/app/services/Non-Master/BillPayPaymentMethod_ehCardDialog.service';
import { BillPayPayment_Package_totalAmountService } from 'src/app/services/Non-Master/BillPayPayment_Package_totalAmount.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-change-pay-payment-dialog',
  templateUrl: './change-pay-payment-dialog.component.html',
  styleUrls: ['./change-pay-payment-dialog.component.css']
})
export class ChangePayPaymentDialogComponent implements OnInit {

  TAG = "ChangePayPaymentDialogComponent";


  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBillPayService: tBillPayService,
    private tPaymentService: tPaymentService,
    private decimalplaceHandler: decimalplaceHandler,
    private apiResultHandlerService: ApiResultHandlerService,
    private billPayPaymentMethod_ehCardDialogService: BillPayPaymentMethod_ehCardDialogService,
    private billPayPayment_Package_totalAmountService: BillPayPayment_Package_totalAmountService,
    readonly translate: TranslateService,

  ) {
    let currentLanguage = localStorage.getItem('currentLanguage');
    translate.use(currentLanguage);
  }

  //UI
  arAmount: number = 0;

  editForm: FormGroup;
  submitted = false;
  formValidSuccessSubmitted = false;

  paymentMethodList: tPaymentModel[] = new Array;

  @Input() dataList: ChangeUnpaidModel[];
  billRemaining: number;
  selectedInvoicePatientIDs = [];
  multiPay=false;
  ngOnInit() {

    this.selectedInvoicePatientIDs = Array.from(new Set(this.dataList.map(x=>x.patientInfo.patientID)));

    if(this.dataList.length>0 && this.dataList.length==1){

      this.multiPay=false;
    }else{



      this.multiPay=true;
    }
    this.editForm = this.formBuilder.group({

      bpArAmount: [],
      paymentWay: [this.paymentMethodList, [Validators.required]],
      payAmount: ['', [Validators.required]],
      billRemaining: [this.billRemaining],
      bpRemark: []

    });



    this.getPaymentMethod();

    this.setArAmount();
  }

  setArAmount() {
    this.arAmount = 0

    this.log.i(this.TAG, "data length = " + this.dataList.length);
    for (var i = 0; i < this.dataList.length; i++) {
      this.arAmount += this.dataList[i].billPayArAmount;
    }
    (<FormControl>this.editForm.controls['bpArAmount']).setValue(this.displayTotalAmt(this.arAmount));
    (<FormControl>this.editForm.controls['payAmount']).setValue(this.displayTotalAmt(this.arAmount));
  }

  displayTotalAmt(amt: number) {
    return this.decimalplaceHandler.convertToValueStr(amt, decimalplaceHandler.dpTotalAmt, decimalplaceHandler.round_TotalAmt);
  }


  getPaymentMethod(): void {
    this.log.i(this.TAG, "do getPaymentMethod");
    var shopID = NavigationComponent.selectedShopID.toString();

    this.tPaymentService.getActiveData(shopID).subscribe(data => {
      this.paymentMethodList = data;
    });
  }

  get f() { return this.editForm.controls; }

  confirm() {
    // this.activeModal.dismiss();
    this.log.i(this.TAG, "do confirm");
    this.submitted = true;

    if (this.editForm.valid) {
      this.formValidSuccessSubmitted = true;

      var specialPaymentType = 0;
      var ehCardConfirmedVoucher = null;

      specialPaymentType = this.paymentMethodList.find(
        (x) => x.paymentID == this.editForm.get("paymentWay").value
      ).specialPaymentType;

      // for (var i = 0; i < this.paymentMethodList.length; i++) {
      //   if (this.editForm.get('paymentWay').value == this.paymentMethodList[i].paymentID) {
      //     specialPaymentType = this.paymentMethodList[i].specialPaymentType;
      //     break;
      //   }
      // }
      if (this.editForm.get('payAmount').value > this.editForm.get('bpArAmount').value)
      {
        alert('付款金額不能大於應付金額');
        this.formValidSuccessSubmitted = false;
        return;
      }
      if (specialPaymentType == 2) {
        //check how many patient selected
        //if > 1 , alert user and close dialog
        if (this.selectedInvoicePatientIDs.length > 1) {
          alert(this.getTranslate("cSpecialPayment2_alert"));
          this.activeModal.close();
        } else {
          // open dialog to input data
          this.log.i(this.TAG, "open ecCardDialog");

          this.billPayPaymentMethod_ehCardDialogService
            .openDialog()
            .result.then(
              (result) => {
                ehCardConfirmedVoucher = JSON.parse(result).ehCardConfirmedID;
                this.log.i(
                  this.TAG,
                  "ehCardDialog voucherID = " + ehCardConfirmedVoucher
                );
                if(this.multiPay==true){
                  console.log("run1");
                  this.submitData(ehCardConfirmedVoucher);

                }else{
                  console.log("run2");
                  this.submitData2(ehCardConfirmedVoucher);

                }

              },
              (reason) => {
                this.log.i(this.TAG, "ehCardDialog cancel reason = " + reason);
                this.formValidSuccessSubmitted = false;
              }
            );
        }
      } else {
        if(this.multiPay==true){
          console.log("run1");
          this.submitData(ehCardConfirmedVoucher);

        }else{
          console.log("run2");
          this.submitData2(ehCardConfirmedVoucher);

        }
      }
    }
  }

  submitData(ehCardConfirmedVoucher?:string){
    var allPaymentData: tBillPayModel[] = new Array;
      for (var p = 0; p < this.dataList.length; p++) {
        var firstBillItem =  this.dataList[p].tbillPayInfo[0];
        var newBillPay = new tBillPayModel();
        newBillPay.shopID = NavigationComponent.selectedShopID.toString();
        newBillPay.bpInvoiceNumber = this.dataList[p].consultHead.clthBillingNumber;
        newBillPay.bpLineNumber = 1;
        newBillPay.bpPaymentNumber = this.editForm.get('paymentWay').value;
        newBillPay.bpDateTime = null;
        newBillPay.bpPatientID = firstBillItem.bpPatientID;
        newBillPay.bpChangeID = firstBillItem.bpChangeID;
        newBillPay.bpConsultNumber = null;
        newBillPay.bpItemID = null;
        newBillPay.bpItemType = BillPay_ItemType.PAYMENT;
        newBillPay.bpItemDesc = null;
        newBillPay.bpQty = null;
        newBillPay.bpStandardPrice = null;
        newBillPay.bpFinalPrice = null;
        newBillPay.bpLineAmount = null;
        newBillPay.bpArAmount = this.dataList[p].billPayArAmount * -1;
        newBillPay.bpPackInvoiceNo = null;
        newBillPay.bpPackItemID = null;
        newBillPay.bpPackageQty = null;
        newBillPay.bpPackFaceAmt = null;
        newBillPay.bpEmployeeID = null;
        newBillPay.bpPrintName = null;
        newBillPay.bpPaymentMethodID = this.editForm.get('paymentWay').value;

        var paymentName: string = null;
        for (var i = 0; i < this.paymentMethodList.length; i++) {
          if (this.editForm.get('paymentWay').value == this.paymentMethodList[i].paymentID) {
            paymentName = this.paymentMethodList[i].paymentName;
          }
        }

        newBillPay.bpPaymentMethodName = paymentName;
        newBillPay.bpRemark = null;
        newBillPay.bpPaymentRemark = null;
        newBillPay.inActive = "N";

        newBillPay.ehVoucher = ehCardConfirmedVoucher;
        newBillPay.lastModifyDatetime = null;
        newBillPay.lastModifyUserID = NavigationComponent.userID;

        allPaymentData.push(newBillPay);
      }


      this.log.i(
        this.TAG,
        "paymentList allPaymentData = " + JSON.stringify(allPaymentData)
      );

      this.tBillPayService.changeMultiPaymentData(allPaymentData).subscribe(
        (data: any) => {
          this.log.i(this.TAG, "onSubmit success");

          this.activeModal.close(data);
          this.log.i(this.TAG, "do confirm data = " + JSON.stringify(data));
        },
        (err) => {
          this.log.i(this.TAG, "onsubmit error = " + JSON.stringify(err));

          if(err.error.custStatusCode){
            let msg = "";

            if(err.error.custStatusCode === "ERROR_BILL_IS_COMPLETED"){
              this.translate.get(err.error.custStatusCode,{invoiceNumber: err.error.data.invoiceNumber}).subscribe(x=>msg = x);
            }else{
              this.translate.get(err.error.custStatusCode).subscribe(x=>msg = x);
            }
            this.formValidSuccessSubmitted = false;
            this.apiResultHandlerService.ErrHandlerWithMessage(msg);
          }else{
            this.apiResultHandlerService.ErrHandler();
          }

        }
      );
  }

  submitData2(ehCardConfirmedVoucher?:string){
    var allPaymentData: tBillPayModel[] = new Array;
      for (var p = 0; p < this.dataList.length; p++) {
        var firstBillItem =  this.dataList[p].tbillPayInfo[0];
        var newBillPay = new tBillPayModel();
        newBillPay.shopID = NavigationComponent.selectedShopID.toString();
        newBillPay.bpInvoiceNumber = this.dataList[p].consultHead.clthBillingNumber;
        newBillPay.bpLineNumber = 1;
        newBillPay.bpPaymentNumber = this.editForm.get('paymentWay').value;
        newBillPay.bpDateTime = null;
        newBillPay.bpPatientID = firstBillItem.bpPatientID;
        newBillPay.bpChangeID = firstBillItem.bpChangeID;
        newBillPay.bpConsultNumber = null;
        newBillPay.bpItemID = null;
        newBillPay.bpItemType = BillPay_ItemType.PAYMENT;
        newBillPay.bpItemDesc = null;
        newBillPay.bpQty = null;
        newBillPay.bpStandardPrice = null;
        newBillPay.bpFinalPrice = null;
        newBillPay.bpLineAmount = null;
        newBillPay.bpArAmount =  this.editForm.get('payAmount').value*-1;
        newBillPay.bpPackInvoiceNo = null;
        newBillPay.bpPackItemID = null;
        newBillPay.bpPackageQty = null;
        newBillPay.bpPackFaceAmt = null;
        newBillPay.bpEmployeeID = null;
        newBillPay.bpPrintName = null;
        newBillPay.bpPaymentMethodID = this.editForm.get('paymentWay').value;

        var paymentName: string = null;
        for (var i = 0; i < this.paymentMethodList.length; i++) {
          if (this.editForm.get('paymentWay').value == this.paymentMethodList[i].paymentID) {
            paymentName = this.paymentMethodList[i].paymentName;
          }
        }

        newBillPay.bpPaymentMethodName = paymentName;
        newBillPay.bpRemark = null;
        newBillPay.bpPaymentRemark = null;
        newBillPay.inActive = "N";

        newBillPay.ehVoucher = ehCardConfirmedVoucher;
        newBillPay.lastModifyDatetime = null;
        newBillPay.lastModifyUserID = NavigationComponent.userID;

        allPaymentData.push(newBillPay);
      }


      this.log.i(
        this.TAG,
        "paymentList allPaymentData = " + JSON.stringify(allPaymentData)
      );

      this.tBillPayService.changeMultiPaymentData(allPaymentData).subscribe(
        (data: any) => {
          this.log.i(this.TAG, "onSubmit success");


          this.activeModal.close(data);
          if(this.billRemaining!=0){
            localStorage.setItem('multiPaymentFinish',"N");
            localStorage.setItem('notFinishedBI',newBillPay.bpInvoiceNumber);
          }

          this.log.i(this.TAG, "do confirm data = " + JSON.stringify(data));
        },
        (err) => {
          this.log.i(this.TAG, "onsubmit error = " + JSON.stringify(err));
          console.log(err);
          if(err.error.custStatusCode){
            let msg = "";

            if(err.error.custStatusCode === "ERROR_BILL_IS_COMPLETED"){
              this.translate.get(err.error.custStatusCode,{invoiceNumber: err.error.data.invoiceNumber}).subscribe(x=>msg = x);
            }else{
              this.translate.get(err.error.custStatusCode).subscribe(x=>msg = x);
            }
            this.formValidSuccessSubmitted = false;
            this.apiResultHandlerService.ErrHandlerWithMessage(msg);
          }else{
            this.apiResultHandlerService.ErrHandler();
          }

        }
      );
  }

  getTranslate(key: string) {
    var returnDisplayMsg: string = "";
    this.translate.get(key).subscribe((res: string) => {
      returnDisplayMsg = res;
    });
    return returnDisplayMsg;
  }

  updateRemainer() {
    //update remainer
    var arAmountInput = this.editForm.get('bpArAmount').value;
    var payAmountInput = this.editForm.get('payAmount').value;

    (<FormControl>this.editForm.controls['billRemaining']).setValue(this.displayTotalAmt(arAmountInput - payAmountInput));

  }
  changePayAmount(inputValue: number) {

    if(inputValue<0){
      (<FormControl>this.editForm.controls['payAmount']).setValue(0);
    }

    this.log.d(this.TAG, "do changePayAmount inputValue = " + inputValue + " , new value = " + (this.arAmount - inputValue));
    // this.UpdateDialogValue();


    (<FormControl>this.editForm.controls['billRemaining']).setValue(this.displayTotalAmt(this.arAmount - inputValue));
    // (<FormControl>this.editForm.controls['billRemaining']).setValue((this.arAmount - inputValue).toFixed(ToFixRange.BillingPayment));
  }



  selectPackage_ReductTotalAmount() {
    this.log.i(this.TAG, "do selectPackage_ReductTotalAmount " + this.editForm.get('payAmount').value);
    localStorage.setItem('multiPayment',"Y");

    const {bpPatientID , bpInvoiceNumber, bpChangeID} = this.dataList[0].tbillPayInfo[0];
    const payAmount = this.editForm.get('payAmount').value;
    const isChangePay = true;

    this.billPayPayment_Package_totalAmountService
    .openDialog(bpPatientID, bpInvoiceNumber, payAmount, isChangePay, bpChangeID).result.then(
      (result) => {

        // var ehCardConfirmedVoucher = JSON.parse(result).ehCardConfirmedID;
        // this.log.i(this.TAG, "ehCardDialog voucherID = " + ehCardConfirmedVoucher);
        // this.submitData(ehCardConfirmedVoucher);

        this.activeModal.close(result);
        localStorage.removeItem('multiPayment');
      }, (reason) => {
        this.log.i(this.TAG, "ehCardDialog cancel reason = " + reason);

      });

  }
}
